import Vue from "vue";
import { loadCheckoutFlow } from "@/utils/loadCheckoutFlow";
import { getPaymentErrorMessage } from "@/utils/extractErrorMessage";

// Shared handoff from a payment modal to CheckoutFlowModal. Both the session
// and the package flow open the same modal with the same response mapping and
// report failures the same way, so each modal only owns building its payload.
//
// The component sets `paymentModalName` as a custom option — the modal that has
// to close behind the handoff.
export default {
  methods: {
    // The SDK bundle needs nothing from the payment-session response, so start
    // the CDN fetch alongside the request instead of after it. loadCheckoutFlow
    // caches, so CheckoutFlowModal's own await then resolves immediately.
    preloadCheckoutFlow() {
      loadCheckoutFlow().catch(() => {
        // the loader clears its cache on failure and CheckoutFlowModal retries,
        // so the user-facing error stays there
      });
    },

    showCheckoutFlow(kind, data) {
      this.$modal.hide("loader-modal");
      this.$modal.hide(this.$options.paymentModalName);
      this.$modal.show("checkout-flow-modal", {
        kind,
        orderId: data.order_id,
        paymentSession: data.payment_session,
        publicKey: data.public_key,
        environment: data.environment
      });
    },

    // v3 reports bad input as a 422 with an `errors` map — an invalid promo
    // code, an unbookable session, an unknown package type. Interpolating the
    // raw error showed the user "Error: AxiosError: Request failed with status
    // code 422" instead.
    onPaymentError(e) {
      Vue.notify({
        group: "errors",
        text: getPaymentErrorMessage(e, this.$t("payments.flow_error")),
        classes: "toast-error"
      });
      this.$modal.hide("loader-modal");
      this.$modal.hide("card-modal");
      this.$modal.hide(this.$options.paymentModalName);
    }
  }
};
